import { useTranslation } from "react-i18next";
import React from "react";
import data from "./countries.json";

export default function InputAuto(props: {
  value: string;
  onChange: any;
  setCountry: React.Dispatch<React.SetStateAction<string>>;
}) {
  const { t } = useTranslation();

  const lang: any = localStorage.getItem("lang") || "en";
  const handleChange = (e: any) => {
    props.onChange(e);
    props.setCountry(e.target.value);
  };

  return (
    <>
      {" "}
      <div className="country">
        <div>
          <label htmlFor="country" className="countryLabel">
            {t("signup__label_country")}
          </label>
        </div>

        <select
          value={props.value}
          defaultValue={props.value}
          onChange={handleChange}
          className="suggestion-auto"
          name="country"
          id="country"
        >
          {data.map((item: any, idx) => (
            <option
              className="country"
              key={"" + item + idx}
              value={item.alpha2}
            >
              {item[lang]}
            </option>
          ))}
        </select>
      </div>
    </>
  );
}
